import { render, staticRenderFns } from "./siteIndex.vue?vue&type=template&id=5caab1c4&scoped=true"
import script from "./siteIndex.vue?vue&type=script&lang=js"
export * from "./siteIndex.vue?vue&type=script&lang=js"
import style0 from "./siteIndex.vue?vue&type=style&index=0&id=5caab1c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caab1c4",
  null
  
)

export default component.exports